export enum EAvailableFaceLanguages {
  ru = "ru",
  en = "en",
  pl = "pl",
  de = "de",
  es = "es",
  az = "az",
  uz = "uz",
  tr = "tr",
  et = "et",
}

export const checkIfRussianLanguage = (
  language: EAvailableFaceLanguages | string
) => {
  return language === EAvailableFaceLanguages.ru;
};

export const checkIfEnglishLanguage = (
  language: EAvailableFaceLanguages | string
) => {
  return language === EAvailableFaceLanguages.en;
};

export const checkIfTurkishLanguage = (
  language: EAvailableFaceLanguages | string
) => {
  return language === EAvailableFaceLanguages.tr;
};

export const checkIfAzerbaijaniLanguage = (
  language: EAvailableFaceLanguages | string
) => {
  return language === EAvailableFaceLanguages.az;
};
